<div class="mt-30 pb-10 footer">
    <div class="footerPatt mt-n16"></div>
    <div class="container">
        <div class="row align-items-start justify-content-between my-1 my-lg-2">

            <div class="col-12 col-md-8 col-lg-6 mb-3 mb-md-0">
                <div class="re-edited-box-icon">
                    <a
                        href="https://raqmi.dga.gov.sa/platforms/platforms/865a373a-5ced-4135-60ed-08dcddedb164/platform-license">
                        <img src="https://raqmi.dga.gov.sa/PlatformsApi/api/Attachments/bae83f25-4398-4b65-9778-b1f700cfdea7"
                            class="img-fluid" alt="Platform License" style="max-width: 400px; height: auto;">
                    </a>
                </div>
            </div>
            <a routerLink="/">
                <img alt="Seec Logo" src="/assets/common/images/logo-on-light.png" class="img-fluid"
                    style="max-width: 150px;">
            </a>
        </div>
    </div>

    <div class="container d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <div class="text-dark order-2 order-md-1">
            <span class="text-white font-weight-bold mr-2">
                جميع الحقوق محفوظة للمركز السعودي لكفاءة الطاقة © 2022
            </span>
        </div>
        <div class="nav order-1 order-md-2">
            <a [routerLink]="['/faq']" class="nav-link text-white pr-lg-0 pl-lg-12">الأسئلة الشائعة</a>
            <a [routerLink]="['/policies-terms']" class="nav-link text-white pr-lg-0 pl-lg-12">سياسة وشروط الخصوصية</a>
            <a [routerLink]="['/terms-of-use']" class="nav-link text-white pr-lg-0 pl-lg-12">أحكام الإستخدام</a>
        </div>
    </div>
</div>